import styled from 'styled-components';

export const DropdownContainer = styled.div`
  position: relative;
  width: 100%;
  padding: 20px;
  font-family: sans-serif;
  background: var(
    --INYECTABLE,
    linear-gradient(180deg, #040916 0%, #0b1733 100%)
  );
  display: none;

  @media (max-width: 550px) {
      /* Phones */
      display: block;
    }

    @media (max-width: 1100px) {
      /* Tablets */
      display: block;
    }
`;

export const DropdownHeader = styled.div`
  width: 80%;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;

  svg{
    margin-left: 8px;
  }
`;

export const DropdownList = styled.ul`
  position: absolute;
  width: 80%;
  background: var(
    --INYECTABLE,
    linear-gradient(180deg, #040916 0%, #0b1733 100%)
  );
  border: 1px solid #ccc;
  border-radius: 6px;
  margin: 0;
  padding: 0;
  list-style: none;
  z-index: 100;
`;

export const DropdownItem = styled.li`
  padding: 10px 12px;
  cursor: pointer;
`;